export const AgentItemsComparativeSalesPerf = {
    "sections": [
      {
        "columns": 4,
        "rows": 1,
        "visual": {
          "id": 14,
          "type": "summary",
          "colorTheme": "colorTheme1",
          "title": "Sales Summary",
          "binding": {
            "data": {
              "title": '',
              "value": '',
              "displayTarget": true,
              "endpoint": "ITEM01",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "ConfigTypeCode", "value": "" },
                { "key": "ItemCode", "value": "" },
                { "key": "EmployeeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
  
                }
              }
            }
          }
        }
      },
      {
        "columns": 8,
        "rows": 3,
        "visual": {
          "id": 1,
          "type": "donut",
          "colorTheme": "colorTheme1",
          "title": "Share by Customer Group Sales",
          "binding": {
            "data": {
              "title": 'CustomerGroup',
              "value": 'Share',
              "tooltip": 'ActualSales',
              "currency": true,
              "percent": true,
              "endpoint": "ITEM04",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "ConfigTypeCode", "value": "" },
                { "key": "ItemCode", "value": "" },
                { "key": "EmployeeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
                  "selectedValueColumn": "CustomerGroup",
                  "selectedTitle": "Channel",
                  "visual": [
                    {
                      "columns": 12,
                      "rows": 2,
                      "visual": {
                        "id": 1,
                        "type": "advancedTable",
                        "colorTheme": "colorTheme1",
                        "title": "Channel",
                        "binding": {
                          "data": {
                            "columns": [
                              {
                                "name": 'Channel',
                                "columnName": 'DistributorCode',
                                "width": '180px',
                                "align": "left",
                                "sortable": true,
                                "sum": false
                              },
                              {
                                "name": 'Actual Sales',
                                "columnName": 'ActualSales',
                                "width": '140px',
                                "align": "right",
                                "sortable": true,
                                "sum": true
                              },
                              {
                                "name": 'LY Sales',
                                "columnName": 'LYSales',
                                "width": '135px',
                                "align": "right",
                                "sortable": true,
                                "sum": true
                              },
                              {
                                "name": 'Growth %',
                                "columnName": 'Growth',
                                "width": '135px',
                                "align": "right",
                                "sortable": true,
                                "sum": false,
                                "percent": true
                              }
                            ],
                            "title": 'DistributorCode',
                            "endpoint": "ITEM04.1",
                            "parameters": [
                              { "key": "FromMonth", "value": "2024" },
                              { "key": "FromYear", "value": "1" },
                              { "key": "ToMonth", "value": "2024" },
                              { "key": "ToYear", "value": "1" },
                              { "key": "CustomerGroup", "value": "" },
                              { "key": "ItemCode", "value": "" },
                              { "key": "ConfigTypeCode", "value": "" },
                              { "key": "EmployeeCode", "value": "" }
                            ]
                          },
                          "context": {
                            "point": {
                              "onClick": {
                                "selectedValueColumn": "CustomerGroupDistributor",
                                "selectedTitle": "Customer",
                                "visual": [
                                  {
                                    "columns": 12,
                                    "rows": 2,
                                    "visual": {
                                      "id": 1,
                                      "type": "advancedTable",
                                      "colorTheme": "colorTheme1",
                                      "title": "Customer",
                                      "binding": {
                                        "data": {
                                          "columns": [
                                            {
                                              "name": 'Customer Name',
                                              "columnName": 'CustomerName',
                                              "width": '400px',
                                              "align": "left",
                                              "sortable": true,
                                              "sum": false
                                            },
                                            {
                                              "name": 'Actual Sales',
                                              "columnName": 'ActualSales',
                                              "width": '140px',
                                              "align": "right",
                                              "sortable": true,
                                              "sum": true
                                            },
                                            {
                                              "name": 'LY Sales',
                                              "columnName": 'LYSales',
                                              "width": '135px',
                                              "align": "right",
                                              "sortable": true,
                                              "sum": true
                                            },
                                            {
                                              "name": 'Growth %',
                                              "columnName": 'Growth',
                                              "width": '135px',
                                              "align": "right",
                                              "sortable": true,
                                              "sum": false,
                                              "percent": true
                                            }
                                          ],
                                          "title": 'CustomerName',
                                          "endpoint": "ITEM04.2",
                                          "parameters": [
                                            { "key": "FromMonth", "value": "2024" },
                                            { "key": "FromYear", "value": "1" },
                                            { "key": "ToMonth", "value": "2024" },
                                            { "key": "ToYear", "value": "1" },
                                            { "key": "CustomerGroupDistributor", "value": "" },
                                            { "key": "ItemCode", "value": "" },
                                            { "key": "ConfigTypeCode", "value": "" },
                                            { "key": "EmployeeCode", "value": "" }
                                          ]
                                        },
                                        "context": {
                                          "point": {
                                            "onClick": {
                                              "selectedValueColumn": "CustomerGroupDistributorCustomerName",
                                              "selectedTitle": "PMR",
                                              "visual": [
                                                {
                                                  "columns": 12,
                                                  "rows": 2,
                                                  "visual": {
                                                    "id": 1,
                                                    "type": "advancedTable",
                                                    "colorTheme": "colorTheme1",
                                                    "title": "PMR",
                                                    "binding": {
                                                      "data": {
                                                        "columns": [
                                                          {
                                                            "name": 'PMR Code',
                                                            "columnName": 'AgentCode',
                                                            "width": '200px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                          },
                                                          {
                                                            "name": 'Employee Code',
                                                            "columnName": 'EmployeeCode',
                                                            "width": '200px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                          },
                                                          {
                                                            "name": 'PMR Name',
                                                            "columnName": 'AgentName',
                                                            "width": '300px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                          },
                                                          {
                                                            "name": 'Actual Sales',
                                                            "columnName": 'ActualSales',
                                                            "width": '140px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                          },
                                                          {
                                                            "name": 'LY Sales',
                                                            "columnName": 'LYSales',
                                                            "width": '135px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                          },
                                                          {
                                                            "name": 'Growth %',
                                                            "columnName": 'Growth',
                                                            "width": '135px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": false,
                                                            "percent": true
                                                          }
                                                        ],
                                                        "title": 'AgentName',
                                                        "endpoint": "ITEM04.3",
                                                        "parameters": [
                                                          { "key": "FromMonth", "value": "2024" },
                                                          { "key": "FromYear", "value": "1" },
                                                          { "key": "ToMonth", "value": "2024" },
                                                          { "key": "ToYear", "value": "1" },
                                                          { "key": "CustomerGroupDistributorCustomerName", "value": "" },
                                                          { "key": "ItemCode", "value": "" },
                                                          { "key": "ConfigTypeCode", "value": "" },
                                                          { "key": "EmployeeCode", "value": "" }
                                                        ]
                                                      },
                                                      "context": {
                                                        "point": {
                                                          "onClick": {
                
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              ]
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                ]
                              }
                            }
                          }
                        }
                      }
                    }
                  ]
                }
              }
            }
          }
        }
      },
      {
        "columns": 4,
        "rows": 1,
        "visual": {
          "id": 1,
          "type": "combo",
          "colorTheme": 'colorTheme1',
          "title": "Actual vs Target (% Performance)",
          "orientation": "vertical",
          "xAxis": "",
          "yAxis": "",
          "binding": {
            "data": {
              "series": [
  
                {
                  "name": 'Sales',
                  "value": 'Sales',
                  "type": 'column'
                },
                {
                  "name": 'Target',
                  "value": 'Target',
                  "type": 'column'
                },
                {
                  "name": 'Performance %',
                  "value": 'Performance',
                  "type": 'line',
                  "percent": true
                }
              ],
              "title": "Month",
              "endpoint": "ITEM02",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "ConfigTypeCode", "value": "" },
                { "key": "ItemCode", "value": "" },
                { "key": "EmployeeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
  
                }
              }
            }
          }
        }
      },
      {
        "columns": 4,
        "rows": 1,
        "visual": {
          "id": 1,
          "type": "combo",
          "colorTheme": 'colorTheme1',
          "title": "Actual Sales vs Last Year (% Growth)",
          "orientation": "vertical",
          "xAxis": "",
          "yAxis": "",
          "binding": {
            "data": {
              "series": [
  
                {
                  "name": 'Sales',
                  "value": 'ActualSales',
                  "type": 'column'
                },
                {
                  "name": 'LY Sales',
                  "value": 'LYSales',
                  "type": 'column'
                },
                {
                  "name": 'Growth %',
                  "value": 'Growth',
                  "type": 'line',
                  "percent": true
                }
              ],
              "title": "Month",
              "endpoint": "ITEM02.1",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "ConfigTypeCode", "value": "" },
                { "key": "ItemCode", "value": "" },
                { "key": "EmployeeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
  
                }
              }
            }
          }
        }
      },
      {
        "columns": 12,
        "rows": 1.5,
        "visual": {
          "id": 1,
          "type": "advancedTable",
          "colorTheme": "colorTheme1",
          "title": "PMR Sales",
          "binding": {
            "data": {
              "columns": [
                {
                  "name": 'PMR Code',
                  "columnName": 'AgentCode',
                  "width": '200px',
                  "align": "left",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": 'Employee Code',
                  "columnName": 'EmployeeCode',
                  "width": '200px',
                  "align": "left",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": 'PMR Name',
                  "columnName": 'AgentName',
                  "width": '200px',
                  "align": "left",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": 'Actual Sales',
                  "columnName": 'ActualSales',
                  "width": '140px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Target Sales',
                  "columnName": 'TargetSales',
                  "width": '140px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Variance',
                  "columnName": 'Variance',
                  "width": '140px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Performance %',
                  "columnName": 'Performance',
                  "width": '160px',
                  "align": "right",
                  "sortable": true,
                },
                {
                  "name": 'LY Sales',
                  "columnName": 'LYSales',
                  "width": '140px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Growth %',
                  "columnName": 'Growth',
                  "width": '140px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                }
              ],
              "title": 'AgentName',
              "endpoint": "ITEM03.2",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "ItemCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" },
                { "key": "EmployeeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
  
                }
              }
            }
          }
        }
      }
    ]
  }